/**
 * @generated SignedSource<<a75129856abd0c041e71a1f5c37fdd82>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Provinces_province$data = {
  readonly name: string;
  readonly province: string | null;
  readonly " $fragmentType": "Provinces_province";
};
export type Provinces_province$key = {
  readonly " $data"?: Provinces_province$data;
  readonly " $fragmentSpreads": FragmentRefs<"Provinces_province">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Provinces_province",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": "province",
      "args": null,
      "kind": "ScalarField",
      "name": "iso3166",
      "storageKey": null
    }
  ],
  "type": "State",
  "abstractKey": null
};

(node as any).hash = "7df566e6b3a076c18720a4d2115efbca";

export default node;
